export default {
  props: {
    items: Object,
    size: String,
  },
  computed: {
    itemCount() {
      return (
        this.items.selectedFiles.length + this.items.selectedFolders.length
      );
    },
  },
};
